// Shared realtime connection bus. Lets flightsRealtime.js and
// clientsRealtime.js share a single /ws-mobile connection per
// (locationId, airplaneId) pair rather than opening duplicates.

import { openRealtime } from './realtimeClient';

const buses = new Map();

function keyFor(locationId, airplaneId) {
  return `${locationId}::${airplaneId || ''}`;
}

export function acquireBus(locationId, airplaneId) {
  const key = keyFor(locationId, airplaneId);
  let entry = buses.get(key);
  if (!entry) {
    const conn = openRealtime({ locationId, airplaneId });
    entry = { conn, refCount: 0 };
    buses.set(key, entry);
  }
  entry.refCount++;
  return {
    on: (ev, fn) => entry.conn.on(ev, fn),
    release: () => {
      entry.refCount--;
      if (entry.refCount <= 0) {
        entry.conn.unsubscribe();
        buses.delete(key);
      }
    },
  };
}
